<template>
  <u-popover
    v-model:visible="munualVisible"
    placement="top-start"
    trigger="click"
    dropdown-class="change-space-dropdown"
  >
    <template #content>
      <div class="home-select">
        <u-scrollbar max-height="260px">
          <div class="home-list">
            <div
              v-for="item in homeList"
              :key="item.job"
              :data-testid="`change-space-${item.homeland}-item`"
              class="home-item h-[44px] mb-[8px]"
              :class="{
                'active-home': item.homeland === homelandInfo.homeland,
                'disabled-home':
                  item.user_status !== 0 && item.user_status !== 3
              }"
              @click="handleChangHome(item)"
            >
              <div class="flex items-center px-[10px] w-full">
                <img
                  :src="spaceIcon"
                  class="w-[28px] h-[28px] mr-[8px] flex-shrink-0 max-w-none"
                  alt="space"
                />
                <div
                  class="flex items-center text-text-neutral-primary gap-[6px] flex-1 justify-between w-[0]"
                >
                  <OneLineText class="flex-1">{{
                    item.homeland_name
                  }}</OneLineText>
                  <span
                    class="home-job flex-shrink-0"
                    :class="{
                      homeJob1: ['home_owner', 'admin'].includes(item.role),
                      homeJob2: item.role === 'home_manager',
                      homeJob3: ['home_member', 'member'].includes(item.role)
                    }"
                    >{{ getRoleText(item.role) || item.response_role }}</span
                  >
                  <span
                    v-if="item.user_status !== 0"
                    class="label"
                    :class="{
                      'opacity-0': item.homeland === homelandInfo.homeland
                    }"
                  >
                    {{
                      item.user_status === 1
                        ? $t(
                            'views.layout.components.BotList.751d94608aa054a3c73ac92a32505b12'
                          )
                        : item.user_status === 2
                        ? $t(
                            'views.layout.components.BotList.61d4936ebd41ff3e2152d942d329b55c'
                          )
                        : $t(
                            'views.layout.components.ChangeSpace.37d579c74f10fdd99c11ee81a344c976'
                          )
                    }}
                  </span>
                </div>
                <BotIcon
                  name="copy"
                  :size="14"
                  :tip="
                    $t(
                      'views.layout.components.ChangeSpace.06d8d856c747b04e84902d542f4dcee0',
                      [item.homeland]
                    )
                  "
                  :padding="4"
                  class="cursor-pointer copy-btn"
                  :data-testid="`copy-space-${item.homeland}-button`"
                  @click.stop="copyText(item.homeland)"
                />
              </div>
            </div>
          </div>
        </u-scrollbar>
        <div class="border-t w-[233px]" />
        <div
          v-permission="'homeland_manage_add'"
          class="home-add flex items-center mr-2"
          data-testid="create-space-button"
          @click="handleCreateHome"
        >
          <div class="fc">
            <u-icon>
              <USolidAdd />
            </u-icon>
          </div>
          <span class="ml10">{{
            $t(
              'views.layout.components.BotList.6066661986293a4d4ae9627257b0e32e'
            )
          }}</span>
        </div>
      </div>
    </template>
    <div
      tabindex="1"
      :style="style"
      data-testid="open-space-switcher-button"
      @click="getHomelandList"
    >
      <template v-if="isMin">
        <div class="h-[44px] flex items-center justify-center fc rounded-[6px]">
          <img
            :src="spaceIcon"
            class="w-[28px] h-[28px] flex-shrink-0 max-w-none"
            alt="space"
          />
        </div>
      </template>

      <template v-if="!isMin">
        <div class="h-[44px] flex items-center">
          <img
            :src="spaceIcon"
            class="w-[28px] h-[28px] mr-[6px] flex-shrink-0 max-w-none"
            alt="space"
          />
          <div class="flex items-center flex-1 min-w-0">
            <div class="flex items-center gap-1 min-w-0 flex-1">
              <span
                class="ellipsis font-semibold text-[14px] mb-[2px] min-w-0 flex-shrink"
                style="min-width: 0"
                >{{ homelandInfo.homeland_name }}</span
              >
              <span
                class="text-[12px] ellipsis text-center home-job flex-shrink-0"
                :class="{
                  homeJob1: ['home_owner', 'admin'].includes(homelandInfo.role),
                  homeJob2: homelandInfo.role === 'home_manager',
                  homeJob3: ['home_member', 'member'].includes(
                    homelandInfo.role
                  )
                }"
                >{{
                  getRoleText(homelandInfo.role) || homelandInfo.response_role
                }}</span
              >
            </div>
          </div>
        </div>
      </template>
    </div>
  </u-popover>
  <SpaceForm ref="spaceFormRef" @change="handleSpaceChange" />
</template>

<script>
import { defineComponent, ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import useHomelandList from '@/hooks/useHomelandList';
import SpaceForm from '@/components/SpaceForm/index.vue';
import { OneLineText } from '@koi-design/vix-components';
import { usePermission } from '@/hooks/usePermission';
import { getCompanyUserPermissionApi } from '@/api/companyUserPermission';
import { spaceIconSrc as spaceIcon } from '@/libs/img';
import { copyText } from '@/libs/clipboard';
import { notifySpaceChange } from '@/libs/accountSync';
console.log(spaceIcon, 'spaceIcon');
export default defineComponent({
  components: {
    SpaceForm,
    OneLineText
  },
  props: {
    isMin: {
      type: Boolean,
      default: false
    },
    style: {
      type: [Object, String],
      default: () => ''
    }
  },
  emits: ['update:visible'],
  setup(_, { emit }) {
    const { t } = useI18n();
    const munualVisible = ref(false);
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    watch(munualVisible, val => {
      emit('update:visible', val);
    });
    const {
      homelandList: homeList,
      getHomelandList,
      refresh
    } = useHomelandList();
    const isCompanyUser = computed(() => store.getters.isCompanyUser);
    const { hasPermission, setPermissions, clearPermissions } = usePermission();

    const updatePermissions = async homelandId => {
      try {
        const res = await getCompanyUserPermissionApi({
          homeland_id: homelandId
        });
        const permissionList = res.resourcesList.map(item => item.englishName);
        setPermissions(permissionList);
      } catch {
        clearPermissions();
      }
    };

    const homelandInfo = computed(() => store.getters.homelandInfo);

    const handleChangHome = async item => {
      if (item.user_status !== 0 && item.user_status !== 3) {
        return;
      }
      if (String(item.homeland) === String(homelandInfo.value?.homeland || '')) {
        munualVisible.value = false;
        return;
      }
      store.commit('updateHomelandId', item);
      await updatePermissions(item.homeland);
      notifySpaceChange(store.getters.botUserInfo?.userId, item.homeland);
      munualVisible.value = false;

      const targetRoute =
        isCompanyUser.value && !hasPermission('work_space_menu')
          ? '/enterprise'
          : '/workspace';
      if (route.path === targetRoute) {
        window.location.href = targetRoute;
      } else {
        router.push(targetRoute);
      }
    };
    // Get translated role text based on role field
    const getRoleText = role => {
      if (role === 'home_owner') {
        return t('api.permission.2fa093b3b799a1735dbe1caa79e6fd59');
      }
      if (role === 'admin') {
        return t('api.permission.a44503926cb1fecdde729aba04221415');
      }
      if (role === 'home_manager') {
        return t('hooks.useRoleOptions.4adca58ada7014c6a2aa022ebf2fd755');
      }
      if (role === 'home_member' || role === 'member') {
        return t('hooks.useRoleOptions.c2be1c3e3ca6951464865dbdd72811c8');
      }
      // Fallback to response_role if role doesn't match
      return null;
    };

    getHomelandList();
    const spaceFormRef = ref(null);
    const handleCreateHome = () => {
      munualVisible.value = false;
      spaceFormRef.value.show();
    };
    const handleSpaceChange = async () => {
      await refresh();
    };
    const colorMap = {
      home_owner: 'var(--text-primary-color-primary-text)',
      admin: 'var(--icon-color-color-orange-weight)',
      home_member: 'var(--text-success-color-success-text-active)'
    };
    return {
      munualVisible,
      handleChangHome,
      homeList,
      homelandInfo,
      spaceFormRef,
      handleCreateHome,
      handleSpaceChange,
      getHomelandList,
      colorMap,
      spaceIcon,
      getRoleText,
      copyText
    };
  }
});
</script>

<style scoped lang="less">
.home-select {
  width: 240px;
  display: flex;
  flex-direction: column;

  :deep(.uui-scrollbar) {
    padding-right: 8px;
  }

  .home-add {
    cursor: pointer;
    height: 40px;
    padding: 0 16px;
    margin-top: 4px;
    border-radius: 6px;
    position: relative;
    color: var(--text-primary-color-primary-text);
    &:hover {
      background: var(--background-control-bg-control-item-hover);
    }
  }
}
.home-list {
  .home-item {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 6px;
    font-weight: 600;
    color: var(--text-netural-color-text-primary);
    .copy-btn {
      display: none;
    }
    &.active-home {
      background: var(--background-control-bg-control-item-hover);
    }
    &.disabled-home {
      cursor: not-allowed;
      opacity: 0.5;
      color: var(--font-color);
      .home-job {
        color: var(--font-color);
        background: var(--form-background-color);
      }
    }
    &:hover {
      &:not(.disabled-home):not(.active-home) {
        background: var(--background-control-bg-control-item-hover);
      }
      .copy-btn {
        display: block;
      }
    }

    .label {
      font-size: 12px;
      flex-shrink: 0;
      margin-left: auto;
      color: var(--color-text-icon-body-secondary);
      background: var(--form-background-color);
      padding: 3px 4px;
      border-radius: 4px;
    }
  }
}
.home-job {
  border-radius: 2px;
  font-size: 11px;
  line-height: 16px;
  padding: 0 4px;
  text-align: center;
  min-width: 44px;
  display: inline-block;
  max-width: 180px;
  flex-shrink: 0;
}
.homeJob1 {
  background: var(--background-info-bg-color-info);
  border: 1px solid var(--border-primary-color-primary-border);
  color: var(--text-primary-color-primary-text);
}
.homeJob2 {
  background: var(--icon-color-color-orange-light);
  border: 1px solid var(--border-warning-color-warning-border-hover);
  color: var(--icon-color-color-orange-weight);
}
.homeJob3 {
  background: var(--background-success-color-success-bg);
  border: 1px solid var(--border-success-color-success-border-hover);
  color: var(--status-success-color-success-active);
}
.current-home {
  cursor: pointer;

  font-size: 14px;
  display: flex;
  align-items: center;
  position: relative;
}
</style>

<style lang="less">
.change-space-dropdown {
  .uui-popover-inner {
    border: none !important;
  }
  .uui-popover-inner-content {
    padding: 8px 0 8px 8px !important;
    border: none !important;
    box-shadow: none !important;
  }
}
</style>
